<template>
  <footer>
    <div class="container">
      <div class="row">
        <div class="col_xl_8 xl_offset_2 col_l_8 l_offset_2 col_m_12 col_s_12">
          <p class="tac title">getsynced</p>

          <h3 class="tac">
            A quick way to connect people and convey emotions in the way we
            love. Let's do it together!
          </h3>

          <div class="footer_links">
            <router-link to="/features" class="hover_op">Features</router-link>
            <router-link to="/pricing" class="hover_op">Pricing</router-link>
            <a href="mailto:test@test.test" class="hover_op"
              ><img src="@/assets/img/envelop_icon.svg" alt="" /> Contact</a
            >
          </div>
        </div>

        <div class="col_xl_12 col_l_12 col_m_12 col_s_12">
          <div class="df s_betwen footer_bottom">
            <p>© 2020, GetSynced</p>

            <div class="df">
              <router-link to="/terms" class="hover_op"
                >Terms of service</router-link
              >
              /
              <router-link to="/privacy" class="hover_op"
                >Privacy policy</router-link
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  computed: {
    authenticated() {
      return this.$store.state.userAuthenticated;
    },
  },
};
</script>

<style lang="scss">
footer {
  background-color: #f4eae1;
  padding-top: 128px;
  padding-bottom: 116px;

  @media all and (max-width: 767px) {
    padding-top: 64px;
    padding-bottom: 64px;
  }

  .footer_links {
    display: flex;
    align-items: center;
    justify-content: center;

    @media all and (max-width: 767px) {
      flex-wrap: wrap;
    }

    a {
      display: flex;
      align-items: center;
      color: #000;
      font-family: "Nunito Sans", sans-serif;
      font-size: 16px;
      font-weight: 700;
      font-style: normal;
      letter-spacing: normal;
      line-height: 24px;
      text-align: left;

      @media all and (max-width: 767px) {
        width: 100%;
        flex: 1 1 100%;
        text-align: center;
        display: block;
      }

      img {
        margin-right: 16px;
        width: 22px;

        @media all and (max-width: 767px) {
          vertical-align: -5px;
        }
      }

      & + a {
        margin-left: 64px;

        @media all and (max-width: 767px) {
          margin-left: 0;
          margin-top: 16px;
        }
      }
    }
  }

  .footer_bottom {
    color: #000;
    font-family: "Nunito Sans", sans-serif;
    font-size: 12px;
    font-weight: 400;
    margin-top: 64px;
    height: 16px;

    @media all and (max-width: 767px) {
      flex-wrap: wrap;
      margin-top: 32px;
      height: auto;

      & > div {
        width: 100%;
        justify-content: center;
        margin-top: 32px;

        a {
          width: auto;
        }
      }
    }

    p,
    a {
      color: #000;
      font-family: "Nunito Sans", sans-serif;
      font-size: 12px;
      font-weight: 400;
      font-style: normal;
      letter-spacing: normal;
      line-height: 16px;
      text-align: right;

      @media all and (max-width: 767px) {
        width: 100%;
        text-align: center;
      }
    }

    a {
      margin-left: 3px;
      margin-right: 3px;
    }
  }

  .title {
    color: #000;
    font-family: "Playfair Display", serif;
    font-size: 48px;
    font-weight: 400;
    line-height: 64px;
    margin-bottom: 64px;

    @media all and (max-width: 767px) {
      font-size: 36px;
      margin-bottom: 32px;
    }
  }

  h3 {
    opacity: 0.64;
    color: #000;
    font-family: "Nunito Sans", sans-serif;
    font-weight: 400;
    line-height: 28px;
    margin-bottom: 64px;

    @media all and (max-width: 767px) {
      margin-bottom: 32px;
    }
  }
}
</style>